import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n	margin-top: 4px;\n	padding: 4px 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n	font-weight: 400;\n	font-size: 1.4rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import Button from "~/components/Button";
import Text from "~/components/Text";
export var StyledButton = styled(Button).withConfig({
    componentId: "sc-b41343bb-0"
})(_templateObject());
export var StyledButtonText = styled(Text).withConfig({
    componentId: "sc-b41343bb-1"
})(_templateObject1());
